import React from 'react';
import { AnchorProps } from '@catalogo/ui-americanas-desktop-product-review/src/types';
import { ReviewPageLink } from './Styled';

const Anchor = ({ children, href, onClick }: AnchorProps) => (
  <ReviewPageLink href={href} title={children} onClick={onClick} className="product-review-anchor" />
);

Anchor.defaultProps = {};

export default Anchor;
export { Anchor };
